<template >
<div class="lineplanner-wrapper container-default d-flex flex-column justify-content-between">
  <modal-message />
<!--  <dev-tool v-if="showDevBar" @clickedClose="closeDevTool" />-->
<!--   <h1 v-html="$t('general.header')"></h1> -->
<!-- <div class="distance"></div> -->
  <HomeView />
  <Footer class="text-center" />
</div>
</template>

<script>
import Footer from './components/App/Footer.vue';
import ModalMessage from './components/ModalMessage.vue';
import HomeView from './views/HomeView.vue';

export default {
    data() {
      return {
        showDevBar: false
      }
    },
    created() {
      this.$store.dispatch('app/findImagePath')
     // let queryString = window.location.search;
     //let urlParams = new URLSearchParams(queryString);
      const pathnames = new URL(window.location.href).pathname.split("/")
      if(pathnames[1]) {
        this.changeLanguage(pathnames[1]);
      } else {
        this.changeLanguage();
      }
      
      const tmp = this;
      // Eventlistener für den Entwicklungsumgebung
      window.addEventListener('keydown', function(event) {
        if(event.key == "B" && event.shiftKey ) {
            tmp.showDevBar = !tmp.showDevBar;
          }
      });
    },
    methods: {
        changeLanguage(language="en") {
            this.$i18n.locale = language;
        },
        closeDevTool() {
          this.showDevBar = false;
        },
        openDevTool() {
          this.showDevBar = true;
        }
    },

    components: { Footer, HomeView, ModalMessage }
}
</script>

<style lang="scss">
@import "./begComponents/style/scss/index.scss";

$fa-font-path: "~beg-icons/web/webfonts";
@import "~beg-icons/web/scss/fontawesome.scss";
@import "~beg-icons/web/scss/custom-icons";
@import "~beg-icons/web/scss/sharp-light";
@import "~beg-icons/web/scss/light";
//@import "../../beg-stylings/scss/main.scss";
@import "beg-stylings/scss/main.scss";

.lineplanner-wrapper {
  min-height: 100vh;
  transition: all 350ms ease;
}
</style>
